import React, { useEffect, useState } from "react";
import { CheckIcon, CloseIcon, WarningIcon } from "@chakra-ui/icons";
import {
  Box,
  Text,
  Flex,
  Icon,
  Button,
  useDisclosure,
  useToast,
  Spinner,
} from "@chakra-ui/react";

import EditModal from "./EditModal";
import ViewModal from "./ViewModal";
import Table from "components/table";
import Topbar from "components/topbar";
import DeclineModal from "./DeclineModal";
import Searchbar from "components/searchbar";
import CustomSelect from "components/select";
import MainLayout from "components/mainLayout";
import InstructionModal from "components/instructionModal";
import { columns } from "./data";
import { SORT_NEWEST_FIRST, SORT_OLDEST_FIRST } from "utils/constants";
import useGetProducts from "api/queries/useGetProducts";
import { useUserContext } from "context/UserContext";
import useApproveProducts from "api/mutations/useApproveProducts";
import { flattenBy } from "@tanstack/react-table";
import useDeclineProducts from "api/mutations/useDeclineProducts";

const Products = () => {
  const toast = useToast();
  const { user } = useUserContext();
  // const [productsData, setProductsData] = useState([]);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState(null);
  const [location, setLocation] = useState("");
  const [selectedProduct, setSelectedProduct] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [statusFilter, setStatusFilter] = useState("");
  const [declineReason, setDeclineReason] = useState("");

  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isEditOpen,
    onOpen: onEditOpen,
    onClose: onEditClose,
  } = useDisclosure();
  const {
    isOpen: isViewOpen,
    onOpen: onViewOpen,
    onClose: onViewClose,
  } = useDisclosure();

  const productsQuery = useGetProducts({
    page: 1,
    limit: 50,
    id: user?.info?._id,
    search,
    sort,
    searchObject: {
      status: statusFilter,
      location: location,
    },
  });
  const productsData = productsQuery.data?.products ?? [];


  // useEffect(() => {
  //   if (productsQuery.isFetching) {
  //     // Clear previous data while fetching new data
  //     setProductsData([]);
  //   } else if (productsQuery?.data?.products) {
  //     setProductsData(productsQuery.data.products);
  //   }
  // }, [productsQuery?.data]);

  useEffect(() => {
    setSelectedRows([]);
    setSelectedProduct({});
  }, [statusFilter]);

  // const handleSelectRow = (isChecked, row) => {
  //   setSelectedRows((prev) =>
  //     isChecked
  //       ? [...prev, row]
  //       : prev.filter((item) => item?.instanceId !== row?.instanceId)
  //   );
  //   setSelectedProduct(row);
  // };

  const columnConfig = columns({
    onEditOpen,
    onViewOpen,
    setSelectedProduct,
    statusFilter,
    // onSelectRow: handleSelectRow,
  });

  // const approveProductMutation = useApproveProducts({
  //   onSuccess: (res) => {
  //     if (res.status === 200) {
  //       toast({
  //         title: res?.data?.message,
  //         status: "success",
  //         duration: 3000,
  //         isClosable: true,
  //       });
  //       setSelectedProduct([]);
  //       setSelectedRows([]);
  //       setStatusFilter("");
  //       productsQuery.refetch();
  //     }
  //   },
  //   onError: (err) => {
  //     const response = err.response;
  //     toast({
  //       title: "Approve product failed.",
  //       description:
  //         response?.data?.message ||
  //         "Something went wrong. Please try again later.",
  //       status: "error",
  //       duration: 3000,
  //       isClosable: true,
  //     });
  //   },
  // });

  // const handeApproveProduct = async () => {
  //   try {
  //     approveProductMutation.mutate(selectedRows);
  //   } catch (e) {
  //     toast({
  //       title: "Something went wrong",
  //       status: "error",
  //       duration: 3000,
  //       isClosable: true,
  //     });
  //   }
  // };

  // const declineProductMutation = useDeclineProducts({
  //   onSuccess: (res) => {
  //     if (res.status === 200) {
  //       toast({
  //         title: res?.data?.message,
  //         status: "success",
  //         duration: 3000,
  //         isClosable: true,
  //       });
  //       setSelectedProduct([]);
  //       setSelectedRows([]);
  //       setStatusFilter("");
  //       onClose();
  //       productsQuery.refetch();
  //     }
  //   },
  //   onError: (err) => {
  //     const response = err.response;
  //     toast({
  //       title: "Decline product failed.",
  //       description:
  //         response?.data?.message ||
  //         "Something went wrong. Please try again later.",
  //       status: "error",
  //       duration: 3000,
  //       isClosable: true,
  //     });
  //   },
  // });

  // const handeDeclineProduct = async () => {
  //   try {
  //     const updatedArray = selectedRows.map((item) => ({
  //       ...item,
  //       reason: declineReason,
  //     }));
  //     declineProductMutation.mutate(updatedArray);
  //   } catch (e) {
  //     toast({
  //       title: "Something went wrong",
  //       status: "error",
  //       duration: 3000,
  //       isClosable: true,
  //     });
  //   }
  // };

  return (
    <MainLayout>
      <Box h={"100%"} minH={"100vh"} paddingBottom={20}>
        <Topbar title={"Products"} />
        <Flex bg={"#f8fbff"} padding={4} height={"100%"} gap={2}>
          <Flex flex={1} direction={"column"} padding={4}>
            <Flex justify={"space-between"} alignItems={"center"} mb={4}>
              <Flex align={"center"}>
                <Searchbar onChange={setSearch} title={"Search"} />
              </Flex>
              <Flex gap={3}>
                <CustomSelect
                  label={"Filter by Location"}
                  onChange={setLocation}
                  defaultValue={location}
                  style={{ maxWidth: "200px" }}
                  inputStyle={{
                    border: "none",
                    background: "#fff",
                    color: "#898989",
                    fontSize: "14px",
                    fontFamily: "PlusJakartaSansMedium",
                  }}
                >
                  <option value="">Select Location</option>
                  <option value={"Hendon"}>Hendon</option>
                  <option value={"Bicestor Village"}>Bicestor Village</option>
                  <option value={"London"}>London</option>
                </CustomSelect>
                <CustomSelect
                  label={"Filter by Status"}
                  defaultValue={statusFilter}
                  onChange={(value) => setStatusFilter(value)}
                  style={{ maxWidth: "200px" }}
                  inputStyle={{
                    border: "none",
                    background: "#fff",
                    color: "#898989",
                    fontSize: "14px",
                    fontFamily: "PlusJakartaSansMedium",
                  }}
                >
                  <option value="">Select Status</option>
                  <option value="sold">Sold</option>
                  <option value="shopify">Live</option>
                  <option value="dry-cleaning">Dry Cleaning</option>
                  <option value="rejected">Rejected</option>
                  <option value="preview">Preview</option>
                  <option value="processing">Processing</option>
                  <option value="image-editing">Image Editing</option>
                  <option value="hidden">Hidden</option>
                </CustomSelect>

                <CustomSelect
                  label={"Sort"}
                  onChange={setSort}
                  style={{ maxWidth: "200px" }}
                  inputStyle={{
                    border: "none",
                    background: "#fff",
                    color: "#898989",
                    fontSize: "14px",
                    fontFamily: "PlusJakartaSansMedium",
                  }}
                >
                  <option value={SORT_NEWEST_FIRST}>Newest First</option>
                  <option value={SORT_OLDEST_FIRST}>Oldest First</option>
                </CustomSelect>
              </Flex>
            </Flex>
            {/* {selectedRows?.length !== 0 && (
              <Box
                bg="#FEE8E7"
                p={4}
                borderRadius="md"
                border="1px solid"
                borderColor="red.200"
              >
                <Flex align="center" justify="space-between">
                  <Flex align="center">
                    <Icon as={WarningIcon} color="red.500" boxSize={5} mr={2} />
                    <Box gap={5}>
                      <Text
                        fontFamily={"PlusJakartaSansRegular"}
                        fontWeight="600"
                        fontSize={"12px"}
                        color="#000000"
                      >
                        Waiting for Approval!
                      </Text>
                      <Text
                        fontFamily={"PlusJakartaSansRegular"}
                        fontWeight="400"
                        fontSize="12px"
                        color="#898989"
                      >
                        There are a total of {selectedRows?.length} products
                        awaiting approval.
                      </Text>
                    </Box>
                  </Flex>
                  <Flex gap={2}>
                    <Button
                      leftIcon={<CloseIcon boxSize={3} />}
                      fontFamily={"PlusJakartaSansRegular"}
                      colorScheme={"none"}
                      width={"167px"}
                      fontSize={"14px"}
                      fontWeight={"500"}
                      border={"1px solid #898989"}
                      bg={"#8989891A"}
                      textColor={"#898989"}
                      onClick={onOpen}
                    >
                      Decline All
                    </Button>
                    <Button
                      leftIcon={
                        approveProductMutation.isLoading ? (
                          ""
                        ) : (
                          <CheckIcon boxSize={3} />
                        )
                      }
                      fontFamily={"PlusJakartaSansRegular"}
                      colorScheme={"none"}
                      width={"167px"}
                      fontSize={"14px"}
                      fontWeight={"500"}
                      bg={"#898989"}
                      textColor={"#FFFFFF"}
                      onClick={handeApproveProduct}
                      disabled={approveProductMutation.isLoading}
                    >
                      {approveProductMutation.isLoading ? (
                        <Spinner />
                      ) : (
                        "Approve All"
                      )}
                    </Button>
                  </Flex>
                </Flex>
              </Box>
            )} */}
            {productsQuery.isFetching ? (
              <Box
                flex={1}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Spinner size={"lg"} />
              </Box>
            ) : (
              <Box minW={"100%"} w={"1px"} overflowX={"auto"}>
                <Table
                  key={statusFilter}
                  columns={columnConfig}
                  data={productsData}
                />
              </Box>
            )}
          </Flex>
        </Flex>
      </Box>
      {/* <DeclineModal
        isOpen={isOpen}
        onClose={onClose}
        handleSubmit={handeDeclineProduct}
        onChangeReason={(e) => setDeclineReason(e.target.value)}
        isLoading={declineProductMutation.isLoading}
      /> */}
      <EditModal isOpen={isEditOpen} onClose={onEditClose} />
      <ViewModal
        isOpen={isViewOpen}
        onClose={onViewClose}
        data={selectedProduct}
      />
    </MainLayout>
  );
};

export default Products;
